
define('core/file_flag',["require", "exports", './api_error'], function(require, exports, api_error) {
    (function (ActionType) {
        ActionType[ActionType["NOP"] = 0] = "NOP";

        ActionType[ActionType["THROW_EXCEPTION"] = 1] = "THROW_EXCEPTION";

        ActionType[ActionType["TRUNCATE_FILE"] = 2] = "TRUNCATE_FILE";

        ActionType[ActionType["CREATE_FILE"] = 3] = "CREATE_FILE";
    })(exports.ActionType || (exports.ActionType = {}));
    var ActionType = exports.ActionType;

    var FileFlag = (function () {
        function FileFlag(flagStr) {
            this.flagStr = flagStr;
            if (FileFlag.validFlagStrs.indexOf(flagStr) < 0) {
                throw new api_error.ApiError(9 /* EINVAL */, "Invalid flag: " + flagStr);
            }
        }
        FileFlag.getFileFlag = function (flagStr) {
            if (FileFlag.flagCache.hasOwnProperty(flagStr)) {
                return FileFlag.flagCache[flagStr];
            }
            return FileFlag.flagCache[flagStr] = new FileFlag(flagStr);
        };

        FileFlag.prototype.isReadable = function () {
            return this.flagStr.indexOf('r') !== -1 || this.flagStr.indexOf('+') !== -1;
        };

        FileFlag.prototype.isWriteable = function () {
            return this.flagStr.indexOf('w') !== -1 || this.flagStr.indexOf('a') !== -1 || this.flagStr.indexOf('+') !== -1;
        };

        FileFlag.prototype.isTruncating = function () {
            return this.flagStr.indexOf('w') !== -1;
        };

        FileFlag.prototype.isAppendable = function () {
            return this.flagStr.indexOf('a') !== -1;
        };

        FileFlag.prototype.isSynchronous = function () {
            return this.flagStr.indexOf('s') !== -1;
        };

        FileFlag.prototype.isExclusive = function () {
            return this.flagStr.indexOf('x') !== -1;
        };

        FileFlag.prototype.pathExistsAction = function () {
            if (this.isExclusive()) {
                return 1 /* THROW_EXCEPTION */;
            } else if (this.isTruncating()) {
                return 2 /* TRUNCATE_FILE */;
            } else {
                return 0 /* NOP */;
            }
        };

        FileFlag.prototype.pathNotExistsAction = function () {
            if ((this.isWriteable() || this.isAppendable()) && this.flagStr !== 'r+') {
                return 3 /* CREATE_FILE */;
            } else {
                return 1 /* THROW_EXCEPTION */;
            }
        };
        FileFlag.flagCache = {};

        FileFlag.validFlagStrs = ['r', 'r+', 'rs', 'rs+', 'w', 'wx', 'w+', 'wx+', 'a', 'ax', 'a+', 'ax+'];
        return FileFlag;
    })();
    exports.FileFlag = FileFlag;
});
//# sourceMappingURL=file_flag.js.map
;